import {
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";

// --- rows (your JSON data) ---
const rows = [
  {
    id: 1,
    searchTerm: "best betting",
    matchType: "Exact",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
  },
  {
    id: 2,
    searchTerm: "betting sites uk",
    matchType: "Broad",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
  },
  {
    id: 3,
    searchTerm: "best betting sites",
    matchType: "Exact",
    AdgroupName: "UK - Betting Sites | Tier 3 |",
  },
];

interface BulkActionModalProps {
  open: boolean;
  onClose: () => void;
}

const SaveChangesThirdST = ({ open, onClose }: BulkActionModalProps) => {
  // --- Define columns ---
  const columns: GridColDef[] = [
    {
      field: "searchTerm",
      headerName: "Search Term",
      flex: 1,
      minWidth: 160,
    },
    {
      field: "matchType",
      headerName: "Match Type",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "AdgroupName",
      headerName: "Adgroup Name",
      flex: 1,
      minWidth: 200,
    },
  ];
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Total Number of Search Terms Who's Negative Definition Is Removed: 3
      </DialogTitle>
      <DialogContent sx={{ padding: "0px 20px 16px" }}>
        <Box sx={{ width: "100%", display: "grid", mt: 1 }}>
          <DataGridPro
            sx={{
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                { outline: "none" },
              "& .MuiDataGrid-cellEmpty": {
                width: "auto",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },

              // row selection only once
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "rgba(156, 39, 176, 0.08) !important",
                "&:hover": {
                  backgroundColor: "rgba(156, 39, 176, 0.16) !important",
                },
              },

              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft": {
                backgroundColor: "#f0def3 !important",
              },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },

              // pinned RIGHT
              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#f0def3 !important",
                },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },
              // make pinned cells transparent → let row bg show through
              "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#ffffff",
                },

              // remove extra blue tint on single cell select
              "& .MuiDataGrid-cell.Mui-selected": {
                backgroundColor: "inherit !important",
              },

              "& .MuiCheckbox-root": {
                color: "#9c27b0 !important",
              },
              "& .MuiCheckbox-root.Mui-checked": {
                color: "#9c27b0",
              },
              border: "none",
            }}
            density="compact"
            hideFooter
            pagination={false}
            rows={rows}
            columns={columns}
            disableColumnMenu
            disableColumnFilter
            disableColumnReorder
            sortingOrder={["asc", "desc"]}
            isCellEditable={() => false}
            disableRowSelectionOnClick
          />
        </Box>
        <Box
          sx={{
            backgroundColor: "#FFF4E5",
            padding: "8px 16px",
            borderRadius: "4px",
            border: "1px solid #ed6c02",
            width: "auto",
            marginTop: 2,
          }}
        >
          <Typography
            align="center"
            color="#ed6c02"
            display="flex"
            alignItems="center"
          >
            <ErrorOutlineOutlinedIcon style={{ marginRight: 5 }} />
            Search Terms Negative Definitions are removed from Adgroup
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "0px 16px 20px 16px" }}>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={onClose} color="secondary" variant="contained">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveChangesThirdST;
